import React from 'react';
import { ChevronDown, CheckCircle2, Lock, FileText, Wallet, BarChart3, Users, Settings, MoreHorizontal, FileCheck, CircleDot, Shield } from 'lucide-react';

const getModuleIcon = (moduleId) => {
  switch (moduleId) {
    case 'revenues': return <CheckCircle2 className="w-5 h-5 text-emerald-600" />;
    case 'expenses': return <Lock className="w-5 h-5 text-emerald-600" />;
    case 'caisses': return <Wallet className="w-5 h-5 text-emerald-600" />;
    case 'factures_bl': return <FileText className="w-5 h-5 text-emerald-600" />;
    case 'tresorerie': return <Lock className="w-5 h-5 text-emerald-600" />;
    case 'pnl': return <BarChart3 className="w-5 h-5 text-emerald-600" />;
    case 'securite_sociale': return <Shield className="w-5 h-5 text-emerald-600" />;
    case 'fournisseurs': return <Users className="w-5 h-5 text-emerald-600" />;
    case 'parametres': return <Settings className="w-5 h-5 text-emerald-600" />;
    case 'users': return <Users className="w-5 h-5 text-emerald-600" />;
    default: return <MoreHorizontal className="w-5 h-5 text-emerald-600" />;
  }
};

function RoleModules({ role, permissions, modules, selectedModule, setSelectedModule, loading }) {
  
  const getModuleStats = (moduleId) => {
    const mod = modules[moduleId];
    const total = mod.gestion.length + mod.consultation.length;
    let allowed = 0;
    
    if (permissions[moduleId]) {
      [...mod.gestion, ...mod.consultation].forEach(p => {
        if (permissions[moduleId][p.id] === true) allowed++;
      });
    }
    return { allowed, total };
  };

  return (
    <div className="flex flex-col h-full bg-white rounded-2xl">
      
      {/* Header */}
      <div className="p-5 border-b border-slate-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 shrink-0">
        <h3 className="font-bold text-slate-900 text-base flex items-center gap-2">
          Permissions du rôle : <span className="text-emerald-600">{role.name}</span>
        </h3>
        
        <div className="flex items-center gap-3 text-[11px] font-bold text-slate-500 flex-wrap">
          <span className="flex items-center gap-1.5"><div className="w-2 h-2 rounded-full bg-emerald-500"></div> Autorisé</span>
          <span className="flex items-center gap-1.5"><div className="w-2 h-2 rounded-full bg-red-500"></div> Refusé</span>
          <span className="flex items-center gap-1.5"><div className="w-2 h-2 rounded-full bg-slate-200"></div> Non défini</span>
        </div>
      </div>

      {/* Modules List */}
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {loading ? (
          <div className="p-8 text-center text-slate-400 font-medium">Chargement des permissions...</div>
        ) : (
          Object.values(modules).map((mod) => {
            const isSelected = selectedModule?.id === mod.id;
            const { allowed, total } = getModuleStats(mod.id);
            
            return (
              <div 
                key={mod.id}
                onClick={() => setSelectedModule(mod)}
                className="flex items-center justify-between p-3 rounded-xl cursor-pointer transition-colors bg-white hover:bg-slate-50"
              >
                <div className="flex items-center gap-4 flex-1">
                  <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                    {getModuleIcon(mod.id)}
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col justify-center">
                    <h4 className="text-sm font-bold text-slate-900 w-full">
                      {mod.name}
                    </h4>
                    <p className="text-xs font-medium text-slate-500 w-full mt-0.5">
                      {mod.description}
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3 shrink-0 ml-4">
                  <span className="text-xs font-bold px-3 py-1 rounded bg-emerald-50 text-emerald-600">
                    {allowed}/{total}
                  </span>
                  <div className="w-8 h-8 rounded bg-slate-50 border border-slate-100 flex items-center justify-center">
                    <ChevronDown className="w-4 h-4 text-slate-600" />
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

    </div>
  );
}

export default RoleModules;
